var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.533,9.563a.749.749,0,0,0-.605-.51l-6.4-.929-2.86-5.8a.749.749,0,0,0-1.344,0l-2.861,5.8-6.395.929a.75.75,0,0,0-.416,1.279l4.628,4.511-1.093,6.37A.751.751,0,0,0,6.28,22L12,19,17.721,22a.747.747,0,0,0,.789-.058.752.752,0,0,0,.3-.733l-1.093-6.37,4.628-4.511A.749.749,0,0,0,22.533,9.563Zm-6.146,4.481a.749.749,0,0,0-.216.664l.9,5.261-4.724-2.485a.751.751,0,0,0-.7,0L6.927,19.969l.9-5.261a.749.749,0,0,0-.216-.664L3.792,10.318l5.281-.766a.75.75,0,0,0,.565-.41L12,4.355l2.361,4.787a.752.752,0,0,0,.566.41l5.281.766Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.f57086fb05710d8092742ff7461126f6.svg";
export { ForwardRef as ReactComponent };